export type MaterialType = 'Kupfer' | 'Aluminium';

export const RHO_KUPFER = 0.0178;
export const RHO_ALUMINIUM = 0.0282;

const createTable = (entries: Array<[number, number]>) => entries.map(([section, load]) => [section, load] as const);

type TableDict = Record<string, ReadonlyArray<readonly [number, number]>>;

type MaterialTables = {
  twoCore: TableDict;
  threeCore: TableDict;
};

const kupferTwoCore: TableDict = {
  A1: createTable([
    [1.5, 14], [2.5, 18.5], [4, 25], [6, 32], [10, 44], [16, 59],
    [25, 77], [35, 95], [50, 115], [70, 146], [95, 175], [120, 201],
    [150, 229], [185, 259], [240, 301], [300, 341]
  ]),
  A2: createTable([
    [1.5, 13.5], [2.5, 17.5], [4, 23], [6, 30], [10, 41], [16, 55],
    [25, 71], [35, 87], [50, 105], [70, 133], [95, 159], [120, 182],
    [150, 207], [185, 234], [240, 272], [300, 308]
  ]),
  B1: createTable([
    [1.5, 17.5], [2.5, 24], [4, 32], [6, 41], [10, 57], [16, 76],
    [25, 98], [35, 122], [50, 151], [70, 192], [95, 228], [120, 262],
    [150, 299], [185, 340], [240, 395], [300, 447]
  ]),
  B2: createTable([
    [1.5, 16.5], [2.5, 22], [4, 29], [6, 37], [10, 52], [16, 69],
    [25, 89], [35, 110], [50, 134], [70, 171], [95, 202], [120, 232],
    [150, 264], [185, 299], [240, 346], [300, 390]
  ]),
  C: createTable([
    [1.5, 19.5], [2.5, 26], [4, 34], [6, 44], [10, 61], [16, 82],
    [25, 108], [35, 133], [50, 160], [70, 208], [95, 250], [120, 289],
    [150, 330], [185, 376], [240, 439], [300, 498]
  ]),
  E: createTable([
    [1.5, 23], [2.5, 31], [4, 42], [6, 54], [10, 75], [16, 101],
    [25, 133], [35, 164], [50, 198], [70, 256], [95, 310], [120, 359],
    [150, 411], [185, 468], [240, 549], [300, 625]
  ]),
  F: createTable([
    [1.5, 23], [2.5, 31], [4, 42], [6, 54], [10, 75], [16, 101],
    [25, 133], [35, 164], [50, 198], [70, 256], [95, 310], [120, 359],
    [150, 411], [185, 468], [240, 549], [300, 625]
  ]),
  G: createTable([
    [1.5, 23], [2.5, 31], [4, 42], [6, 54], [10, 75], [16, 101],
    [25, 133], [35, 164], [50, 198], [70, 256], [95, 310], [120, 359],
    [150, 411], [185, 468], [240, 549], [300, 625]
  ])
};

const kupferThreeCore: TableDict = {
  A1: createTable([
    [1.5, 12], [2.5, 16], [4, 21], [6, 27], [10, 37], [16, 50],
    [25, 64], [35, 79], [50, 96], [70, 121], [95, 145], [120, 166],
    [150, 189], [185, 213], [240, 247], [300, 279]
  ]),
  A2: createTable([
    [1.5, 11.5], [2.5, 15], [4, 20], [6, 26], [10, 35], [16, 47],
    [25, 60], [35, 73], [50, 89], [70, 112], [95, 133], [120, 152],
    [150, 173], [185, 196], [240, 227], [300, 256]
  ]),
  B1: createTable([
    [1.5, 15], [2.5, 20], [4, 27], [6, 35], [10, 49], [16, 65],
    [25, 84], [35, 103], [50, 128], [70, 163], [95, 193], [120, 221],
    [150, 252], [185, 286], [240, 331], [300, 374]
  ]),
  B2: createTable([
    [1.5, 14], [2.5, 19], [4, 25], [6, 32], [10, 44], [16, 59],
    [25, 75], [35, 92], [50, 113], [70, 144], [95, 170], [120, 194],
    [150, 220], [185, 250], [240, 289], [300, 326]
  ]),
  C: createTable([
    [1.5, 17], [2.5, 23], [4, 30], [6, 38], [10, 53], [16, 71],
    [25, 93], [35, 115], [50, 138], [70, 179], [95, 215], [120, 247],
    [150, 282], [185, 321], [240, 373], [300, 422]
  ]),
  E: createTable([
    [1.5, 20], [2.5, 27], [4, 36], [6, 46], [10, 64], [16, 86],
    [25, 112], [35, 138], [50, 168], [70, 217], [95, 262], [120, 302],
    [150, 346], [185, 394], [240, 461], [300, 523]
  ]),
  F: createTable([
    [1.5, 20], [2.5, 27], [4, 36], [6, 46], [10, 64], [16, 86],
    [25, 112], [35, 138], [50, 168], [70, 217], [95, 262], [120, 302],
    [150, 346], [185, 394], [240, 461], [300, 523]
  ]),
  G: createTable([
    [1.5, 20], [2.5, 27], [4, 36], [6, 46], [10, 64], [16, 86],
    [25, 112], [35, 138], [50, 168], [70, 217], [95, 262], [120, 302],
    [150, 346], [185, 394], [240, 461], [300, 523]
  ])
};

const aluminiumTwoCore: TableDict = {
  A1: createTable([
    [2.5, 14.5], [4, 19.5], [6, 25], [10, 34], [16, 46], [25, 60],
    [35, 74], [50, 90], [70, 114], [95, 137], [120, 157], [150, 179],
    [185, 203], [240, 236], [300, 267]
  ]),
  A2: createTable([
    [2.5, 13.5], [4, 18], [6, 23], [10, 32], [16, 43], [25, 55],
    [35, 68], [50, 82], [70, 104], [95, 124], [120, 143], [150, 162],
    [185, 183], [240, 213], [300, 241]
  ]),
  B1: createTable([
    [2.5, 18.5], [4, 25], [6, 32], [10, 44], [16, 59], [25, 76],
    [35, 95], [50, 118], [70, 150], [95, 178], [120, 205], [150, 234],
    [185, 266], [240, 309], [300, 350]
  ]),
  B2: createTable([
    [2.5, 17], [4, 23], [6, 29], [10, 40], [16, 54], [25, 69],
    [35, 86], [50, 105], [70, 133], [95, 158], [120, 181], [150, 206],
    [185, 234], [240, 271], [300, 306]
  ]),
  C: createTable([
    [2.5, 20], [4, 27], [6, 34], [10, 46], [16, 61], [25, 80],
    [35, 99], [50, 122], [70, 157], [95, 188], [120, 216], [150, 245],
    [185, 279], [240, 325], [300, 367]
  ]),
  E: createTable([
    [2.5, 24], [4, 32], [6, 42], [10, 58], [16, 78], [25, 103],
    [35, 127], [50, 154], [70, 198], [95, 240], [120, 278], [150, 318],
    [185, 362], [240, 425], [300, 483]
  ]),
  F: createTable([
    [2.5, 24], [4, 32], [6, 42], [10, 58], [16, 78], [25, 103],
    [35, 127], [50, 154], [70, 198], [95, 240], [120, 278], [150, 318],
    [185, 362], [240, 425], [300, 483]
  ]),
  G: createTable([
    [2.5, 24], [4, 32], [6, 42], [10, 58], [16, 78], [25, 103],
    [35, 127], [50, 154], [70, 198], [95, 240], [120, 278], [150, 318],
    [185, 362], [240, 425], [300, 483]
  ])
};

const aluminiumThreeCore: TableDict = {
  A1: createTable([
    [2.5, 12.5], [4, 16.5], [6, 21], [10, 29], [16, 39], [25, 50],
    [35, 61], [50, 75], [70, 94], [95, 113], [120, 130], [150, 148],
    [185, 167], [240, 194], [300, 219]
  ]),
  A2: createTable([
    [2.5, 11.5], [4, 15.5], [6, 20], [10, 27], [16, 37], [25, 47],
    [35, 57], [50, 70], [70, 87], [95, 104], [120, 119], [150, 135],
    [185, 153], [240, 178], [300, 201]
  ]),
  B1: createTable([
    [2.5, 15.5], [4, 21], [6, 27], [10, 38], [16, 51], [25, 66],
    [35, 81], [50, 99], [70, 127], [95, 150], [120, 172], [150, 196],
    [185, 222], [240, 258], [300, 291]
  ]),
  B2: createTable([
    [2.5, 14.5], [4, 19.5], [6, 25], [10, 35], [16, 46], [25, 59],
    [35, 72], [50, 88], [70, 112], [95, 133], [120, 152], [150, 172],
    [185, 195], [240, 226], [300, 255]
  ]),
  C: createTable([
    [2.5, 18], [4, 24], [6, 31], [10, 43], [16, 57], [25, 75],
    [35, 92], [50, 111], [70, 143], [95, 171], [120, 196], [150, 224],
    [185, 254], [240, 296], [300, 334]
  ]),
  E: createTable([
    [2.5, 21], [4, 28], [6, 36], [10, 50], [16, 67], [25, 88],
    [35, 108], [50, 131], [70, 169], [95, 204], [120, 234], [150, 268],
    [185, 305], [240, 357], [300, 404]
  ]),
  F: createTable([
    [2.5, 21], [4, 28], [6, 36], [10, 50], [16, 67], [25, 88],
    [35, 108], [50, 131], [70, 169], [95, 204], [120, 234], [150, 268],
    [185, 305], [240, 357], [300, 404]
  ]),
  G: createTable([
    [2.5, 21], [4, 28], [6, 36], [10, 50], [16, 67], [25, 88],
    [35, 108], [50, 131], [70, 169], [95, 204], [120, 234], [150, 268],
    [185, 305], [240, 357], [300, 404]
  ])
};

const MATERIAL_TABLES: Record<MaterialType, MaterialTables> = {
  Kupfer: {
    twoCore: kupferTwoCore,
    threeCore: kupferThreeCore
  },
  Aluminium: {
    twoCore: aluminiumTwoCore,
    threeCore: aluminiumThreeCore
  }
};

const installationPrefixes = ['A1', 'A2', 'B1', 'B2', 'C', 'E', 'F', 'G'];

const resolveInstallationKey = (installation: string) => {
  const trimmed = installation.trim();
  const found = installationPrefixes.find(prefix => trimmed.startsWith(prefix));
  return found ?? '';
};

export const getCapacityTable = (
  material: MaterialType,
  cores: 2 | 3,
  installation: string
): ReadonlyArray<readonly [number, number]> | null => {
  const materialTables = MATERIAL_TABLES[material];
  if (!materialTables) return null;
  const key = resolveInstallationKey(installation);
  if (!key) return null;
  const dict = cores === 2 ? materialTables.twoCore : materialTables.threeCore;
  return dict[key] ?? null;
};

export const TEMPERATURE_CORRECTION_FACTORS: Array<{ maxTemp: number; factor: number }> = [
  { maxTemp: 20, factor: 1.12 },
  { maxTemp: 25, factor: 1.06 },
  { maxTemp: 30, factor: 1.0 },
  { maxTemp: 35, factor: 0.94 },
  { maxTemp: 40, factor: 0.87 },
  { maxTemp: 45, factor: 0.79 },
  { maxTemp: 50, factor: 0.71 }
];

export const getTemperatureCorrectionFactor = (ambientTemp: number): number => {
  if (Number.isNaN(ambientTemp)) return 1.0;
  if (ambientTemp > 50) return 0.61;
  for (const entry of TEMPERATURE_CORRECTION_FACTORS) {
    if (ambientTemp <= entry.maxTemp) return entry.factor;
  }
  return 1.12;
};

export const roundToDecimals = (value: number, decimals: number): number => {
  const multiplier = 10 ** decimals;
  return Math.round(value * multiplier) / multiplier;
};

export const formatDecimal = (value: number, decimals = 3): string => {
  if (!Number.isFinite(value)) return '0';
  return value.toLocaleString('de-DE', {
    minimumFractionDigits: value % 1 === 0 ? 0 : Math.min(decimals, 3),
    maximumFractionDigits: decimals
  });
};
